module.exports = __webpack_public_path__ + "static/media/Αλλα σχολεια κωφων.dff92e2f.mp4";